module.exports = __webpack_public_path__ + "static/form-default-values-do-df18a087c189a9db682a2202ad677428.png";